/**
 * frameOwnership — does THIS frame belong to THIS chat?
 *
 * One socket serves every chat, so arrival says nothing about ownership. The
 * backend addresses a turn to the `wps_conn_id` from its POST, and every chat
 * posts the same id — a connection is a DESTINATION, not a filter. Pure:
 * primitives in, boolean out.
 */

export interface FrameOwnershipInput {
  frameChatId?: string;
  myServerId?: string;
  claimedByAnother: () => boolean;
}

/** `true` when this chat should process the frame. See the table above. */
export function ownsFrame({
  frameChatId,
  myServerId,
  claimedByAnother
}: FrameOwnershipInput): boolean {
  if (frameChatId === undefined) {
    return true;
  }
  if (myServerId !== undefined) {
    return frameChatId === myServerId;
  }
  return !claimedByAnother();
}
